import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import Beyond from '../components/section/beyond_academics';
import Career from '../components/section/career';
import Cbse from '../components/section/cbse';
import Enroll2 from '../components/section/enroll2';
import Infrastructure from '../components/section/infrastructure';
import LifeAtInnovera from '../components/section/life_at_innovera';
  import config from '../constant';


class EnrollMain extends Component {
    componentDidMount(){
        document.title = "Enroll Now | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <Enroll2/>
             <Footer/>


        </div>
    );

}
    }
export default EnrollMain;